var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataShow)?_c('div',{staticClass:"c-alert animated fadeIn"},[_c('b-alert',{attrs:{"show":"","variant":_vm.dataVariant}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataMessage)}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }